import { useCallback } from 'react';
import Button from '@cloudscape-design/components/button';
import { REQUEST_DETAILS_TEMPLATE_URL } from '../constants';
import { reportDetailPath } from '../router';

export interface RequestDetailsButtonProps {
  reportId: string;
}

export function RequestDetailsButton({ reportId }: RequestDetailsButtonProps) {
  const copyPermalink = useCallback(() => {
    const permalink = `${window.location.origin}${reportDetailPath(reportId)}`;
    // Best effort: clipboard may be unavailable (permissions, old browser);
    // the ticket form still opens and the requester pastes or types the link.
    void navigator.clipboard?.writeText(permalink).catch(() => {});
  }, [reportId]);

  return (
    <Button
      href={REQUEST_DETAILS_TEMPLATE_URL}
      external
      onClick={copyPermalink}
      i18nStrings={{ externalIconAriaLabel: '(opens ticket form in new tab)' }}
    >
      Request Further Research
    </Button>
  );
}
